module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "index"
    }
  }, [_c('header', {
    staticClass: "am-topbar"
  }, [_c('OffCanvas', {
    staticClass: "meun"
  }, [_vm._v("边侧栏")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "am-slider am-slider-default"
  }, [_c('ul', {
    staticClass: "am-slides"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.openApp(2)
      }
    }
  }, [_c('img', {
    staticClass: "am-img-responsive",
    attrs: {
      "src": require("./业务办理广告@3x.png")
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.openApp(0)
      }
    }
  }, [_c('img', {
    staticClass: "am-img-responsive",
    attrs: {
      "src": require("./开户广告@3x.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "gnlb"
  }, [_c('div', {
    staticClass: "am-g"
  }, [_c('div', {
    staticClass: "am-u-sm-6",
    on: {
      "click": function($event) {
        return _vm.openApp(0)
      }
    }
  }, [_c('div', {
    staticClass: "qhkh"
  }), _vm._v(" "), _c('div', {
    staticClass: "gnlb_title"
  }, [_vm._v("期货开户")])]), _vm._v(" "), _c('div', {
    staticClass: "am-u-sm-6",
    on: {
      "click": _vm.goToDownload
    }
  }, [_c('div', {
    staticClass: "qhjy"
  }), _vm._v(" "), _c('div', {
    staticClass: "gnlb_title"
  }, [_vm._v("期货交易")])]), _vm._v(" "), _c('div', {
    staticClass: "am-u-sm-6",
    on: {
      "click": function($event) {
        return _vm.openApp(0)
      }
    }
  }, [_c('div', {
    staticClass: "flcx"
  }), _vm._v(" "), _c('div', {
    staticClass: "gnlb_title"
  }, [_vm._v("费率查询")])]), _vm._v(" "), _c('div', {
    staticClass: "am-u-sm-6",
    on: {
      "click": function($event) {
        return _vm.openApp(2)
      }
    }
  }, [_c('div', {
    staticClass: "ywbl"
  }), _vm._v(" "), _c('div', {
    staticClass: "gnlb_title"
  }, [_vm._v("业务办理")])]), _vm._v(" "), _c('div', {
    staticClass: "am-u-sm-6",
    on: {
      "click": function($event) {
        return _vm.openApp(1)
      }
    }
  }, [_c('div', {
    staticClass: "lhmj"
  }), _vm._v(" "), _c('div', {
    staticClass: "gnlb_title"
  }, [_vm._v("蓝海密剑")])]), _vm._v(" "), _c('div', {
    staticClass: "am-u-sm-6",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'zcgl',
          params: {
            nr: 'login'
          }
        })
      }
    }
  }, [_c('div', {
    staticClass: "zcgl"
  }), _vm._v(" "), _c('div', {
    staticClass: "gnlb_title"
  }, [_vm._v("资产管理")])])])]), _vm._v(" "), _c('div', {
    staticClass: "gsgg"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    class: {
      active: _vm.currentView === 'gsgg'
    },
    on: {
      "click": function($event) {
        return _vm.tabToggle("gsgg");
      }
    }
  }, [_vm._v("公司公告")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.currentView === 'jys'
    },
    on: {
      "click": function($event) {
        return _vm.tabToggle("jys");
      }
    }
  }, [_vm._v("交易所公告")]), _vm._v(" "), _c('span', {
    class: {
      active: _vm.currentView === 'bzj'
    },
    on: {
      "click": function($event) {
        return _vm.tabToggle("bzj");
      }
    }
  }, [_vm._v("保证金公告")])]), _vm._v(" "), _c('div', [_c('List', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView == 'gsgg'),
      expression: "currentView=='gsgg'"
    }],
    attrs: {
      "list": _vm.gsgg,
      "name": "gsgg",
      "ShowTime": true,
      "count": 5
    }
  }), _vm._v(" "), _c('List', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView == 'jys'),
      expression: "currentView=='jys'"
    }],
    attrs: {
      "list": _vm.jys,
      "name": "jys",
      "ShowTime": true,
      "count": 5
    }
  }), _vm._v(" "), _c('List', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView == 'bzj'),
      expression: "currentView=='bzj'"
    }],
    attrs: {
      "list": _vm.bzj,
      "name": "bzj",
      "ShowTime": true,
      "count": 5
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ShowMore",
    staticStyle: {
      "display": "inherit"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'gg',
        params: {
          nr: _vm.currentView
        }
      }
    }
  }, [_vm._v("点击查看更多")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "cjwt"
  }, [_c('div', {
    staticClass: "cjwttitle"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'cjwt'
      }
    }
  }, [_vm._v("常见问题")])], 1)]), _vm._v(" "), _c('List', {
    attrs: {
      "list": _vm.zzwd,
      "name": "cjwt",
      "count": 5
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ShowMore",
    staticStyle: {
      "display": "inherit"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'cjwt'
      }
    }
  }, [_vm._v("点击查看更多")])], 1)], 1), _vm._v(" "), _c('ICP')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "logo"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-408743eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/index.vue
// module id = 819
// module chunks = 2